<template>
    <div>
        <Modal v-model="mainTable.sarchCardShow"
            :width="1000"
            :footer-hide="true"
            title="搜素">
            <search-card :form="type==='summary' ? mainTable.searchForm : mainTable.detailSearchForm"
                :table-load-event="getWarehouseEntryTableRecord"
                :table-search="mainTable.tableSearch" />
        </Modal>
        <!-- <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition> -->
        <Modal v-model="show"
            :width="70"
            :footer-hide="true"
            title="入库记录"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">现售入库单列表</span>
                            <RadioGroup v-model="type"
                                @on-change="onTypeChange">
                                <Radio label="summary">汇总</Radio>
                                <Radio label="detail">明细</Radio>
                            </RadioGroup>
                        </div>
                        <div class="right-bar">
                            <Button v-if="$checkAccessArray(['B', 'C'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateWarehouseEntry">新增</Button>

                            <Button type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                        </div>
                    </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                    <stand-pagination-table :columns="type==='summary'  ? mainTable.columns :mainTable.detailColumns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :extHeight="200"
                        :table-load-event="getWarehouseEntryTableRecord" />
                    </Col>
                </Row>
            </Card>
        </Modal>

        <Modal v-model="approvalModal.show"
            title="入库审批"
            @on-ok="confirmApproval"
            @on-cancel="approvalModal.show = false"
            class-name="vertical-center-modal">
            <RadioGroup v-model="approvalModal.warehouseEntryRecordIsApproval">
                <Radio :label="APPROVAL_YES"><span>通过</span></Radio>
                <Radio :label="APPROVAL_NO"><span>不通过</span></Radio>
            </RadioGroup>
        </Modal>

        <CurSaleWarehouseEntryEdit ref='curSaleWarehouseEntryEditModal' />
        <WarehouseEntryDetail ref="warehouseEntryDetailModel" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateRender } from '@/libs/tableRowTimeRender';
import CurSaleWarehouseEntryEdit from './curSale-warehouse-entry-edit';
import WarehouseEntryDetail from './curSale-warehouse-entry-detail';
import { getCurSaleWarehouseEntryList, getCurSaleWarehouseEntryFullList, withdrawCurSaleWarehouseEntry, approvalCurSaleWarehouseEntry, saveCurSaleWarehouseNegativeEntry } from '@/api/modules/warehouse-management/warehouseEntry';
import { approvalFormat, statusFormat, APPROVAL_YES, APPROVAL_NO, APPROVAL_INREVIEW } from '@/libs/baseModelFormat';

export default {
    name: 'CurWarehouseEntryList',
    components: {
        SearchCard,
        StandPaginationTable,
        CurSaleWarehouseEntryEdit,
        WarehouseEntryDetail
    },
    data() {
        return {
            show: false,
            type: 'summary',
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '单号', key: 'warehouseEntryRecordBillCode', width: 200, align: 'center' },
                    { title: '批次', key: 'warehouseEntryRecordBatchCode', align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center' },
                    { title: '项目', key: 'warehouseEntryRecordProject', align: 'center' },
                    { title: '制单人', key: 'userPersonName', align: 'center' },
                    { title: '入库日期', key: 'warehouseEntryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseEntryRecordCreateAt) },
                    {
                        title: '审核状态',
                        key: 'warehouseEntryRecordIsApproval',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.warehouseEntryRecordIsApproval))
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 120,
                        render: (h, params) => {
                            const withdrawElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.withDrawEntry(params.row);
                                    }
                                }
                            }, '撤回');
                            const approvalElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.onApproval(params.row);
                                    }
                                }
                            }, '审批');
                            const saveNegativeElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.onSaveNegativeEntry(params.row.warehouseEntryRecordUuid);
                                    }
                                }
                            }, '冲抵');
                            let showElements = [h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.warehouseEntryDetailModel.showModal(params.row.warehouseEntryRecordUuid);
                                    }
                                }
                            }, '查看')];
                            if (params.row.canSaveNegative === 1) {
                                showElements.push(saveNegativeElement);
                            }
                            if (params.row.warehouseEntryRecordIsApproval !== APPROVAL_YES && this.$checkAccessArray(['B', 'C'])) {
                                showElements.push(withdrawElement);
                            }
                            if (params.row.warehouseEntryRecordIsApproval === APPROVAL_INREVIEW && this.$checkAccessArray(['H'])) {
                                showElements.push(approvalElement);
                            }
                            return h('div', showElements);
                        }
                    }
                ],
                detailColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '单号', key: 'warehouseEntryRecordBillCode', width: 200, align: 'center' },
                    { title: '批次', key: 'warehouseEntryRecordBatchCode', align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center' },
                    { title: '产品编号', key: 'warehouseEntryDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'warehouseEntryDetailProductName', align: 'center' },
                    { title: '入库量', key: 'warehouseEntryDetailAmount', align: 'center' },
                    { title: '销售周期', key: 'warehouseEntryDetailSalePeriod', align: 'center' },
                    { title: '入库日期', key: 'warehouseEntryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseEntryRecordCreateAt) },
                    { title: '备注', key: 'warehouseEntryDetailRemark', align: 'center' }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '单号', type: 'Input', value: '', name: 'warehouseEntryRecordBillCode', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '批次', type: 'Input', value: '', name: 'warehouseEntryRecordBatchCode', sql: 'like' },
                    { label: '入库日期', type: 'Daterange', value: '', name: 'warehouseEntryRecordCreateAt', sql: 'dateBetween' }
                ],
                detailSearchForm: [
                    { label: '单号', type: 'Input', value: '', name: 'warehouseEntryRecordBillCode', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '批次', type: 'Input', value: '', name: 'warehouseEntryRecordBatchCode', sql: 'like' },
                    { label: '产品信息', type: 'Input', value: '', name: 'concat(warehouseEntryDetailProductCode,warehouseEntryDetailProductName)', sql: 'like' },
                    { label: '入库日期', type: 'Daterange', value: '', name: 'warehouseEntryRecordCreateAt', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            approvalModal: {
                show: false,
                entryCode: '',
                warehouseEntryRecordUuid: '',
                warehouseEntryRecordIsApproval: 1
            },
            APPROVAL_YES,
            APPROVAL_NO

        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.getWarehouseEntryTableRecord();
        },
        onSaveNegativeEntry(warehouseEntryRecordUuid) {
            this.$Modal.confirm({
                title: '确认冲抵入库单',
                onOk: () => {
                    this.mainTable.loading = true;
                    saveCurSaleWarehouseNegativeEntry({ warehouseEntryRecordUuid: warehouseEntryRecordUuid }).then(res => {
                        this.mainTable.loading = false;
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('冲抵成功');
                        }
                    });
                }
            });

        },
        withDrawEntry(row) {
            this.$Modal.confirm({
                title: '确认撤回该入库单',
                onOk: () => {
                    let data = {
                        warehouseEntryRecordUuid: row.warehouseEntryRecordUuid
                    };
                    withdrawCurSaleWarehouseEntry(data).then(res => {
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('撤回成功');
                        }
                    });
                }
            });
        },
        onApproval(row) {
            this.approvalModal.entryCode = row.warehouseEntryRecordBillCode;
            this.approvalModal.warehouseEntryRecordUuid = row.warehouseEntryRecordUuid;
            this.approvalModal.warehouseEntryRecordIsApproval = APPROVAL_YES;
            this.approvalModal.show = true;
        },
        confirmApproval() {
            approvalCurSaleWarehouseEntry(this.approvalModal).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '审批成功',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            });
        },
        onTypeChange() {
            this.getWarehouseEntryTableRecord(true);
        },
        getWarehouseEntryTableRecord(reset = false) {

            if (reset) {
                // search.globalResetSearch(this.mainTable.tableSearch);
                this.mainTable.tableSearch = search.getSearchParams();

            }
            if (this.type === 'summary') {
                this.mainTable.loading = true;
                getCurSaleWarehouseEntryList(this.mainTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                    }

                    this.mainTable.loading = false;
                });
            }
            else if (this.type === 'detail') {
                this.mainTable.loading = true;
                getCurSaleWarehouseEntryFullList(this.mainTable.tableSearch).then(res => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                    }

                    this.mainTable.loading = false;
                });
            }
        },
        onCreateWarehouseEntry() {
            this.$refs.curSaleWarehouseEntryEditModal.showModal();
            // this.$router.push({ name: 'curSale-warehouse-entry-edit' });
        }
    }
};
</script>

<style lang="less">
</style>
